import '../styles/main.scss'
import React from 'react'
import { createRoot } from 'react-dom/client'
import Fancybox from "./utils/fancybox";
import Accordion from './components/accordion'
import BasicModal from './components/basicModal'
import Slider from './components/slider'
import Base from './components/base'

import AOS from 'aos'
import 'aos/dist/aos.css'

document.addEventListener('DOMContentLoaded', () => {
    Fancybox();
    AOS.init();

    /*
    Base
     */

    const base = document.querySelector('.base');
    if (base) {
        createRoot(base).render(<Base items="Just a demo content for base React component. In case I forget how React works :D"/>);
    }

    /*
        Slider
     */
    const slider = document.querySelector('.slider');
    if (slider) {
        createRoot(slider).render(<Slider items={sliderData}/>);
    }

    /*
    * Accordion
    * */
    const accordion = document.querySelector('.accordion');
    if (accordion) {
        createRoot(accordion).render(<Accordion items={repeaterData}/>);
    }

    const tabs = document.querySelector('.repeater-tabs');
    if (tabs) {
        createRoot(tabs).render(<VerticalTabs items={repeaterData}/>);
    }


    /*
    * Labels */
    document.addEventListener('focus', (e) => {
        if (e.target.matches('.form-input, .form-textarea')) {
            const parent = e.target.closest('.input-group');
            parent.classList.add('focused');
        }
    }, true);

    document.addEventListener('blur', (e) => {
        if (e.target.matches('.form-input, .form-textarea')) {
            const parent = e.target.closest('.input-group');
            e.target.value ? parent.classList.add('has-value') : parent.classList.remove('focused', 'has-value');
        }
    }, true);

    document.addEventListener('input', (e) => {
        if (e.target.matches('.form-input, .form-textarea')) {
            const parent = e.target.closest('.input-group');
            e.target.value ? parent.classList.add('has-value') : parent.classList.remove('has-value');
        }
    });

    /*
    Modal
     */

    const modal = document.querySelector('.modal');
    if (modal) {
        createRoot(modal).render(<BasicModal items={modalData}/>);
    }

    /*
    Scroll to top button
     */

    /*
    Change header on scroll
     */
    const header = document.getElementById("masthead");
    window.addEventListener("scroll", function () {
        const scroll = window.scrollY;
        if (scroll >= 50) {
            header.classList.add("scrolled");
        } else {
            header.classList.remove("scrolled");
        }
    });

    /*
    Toggle mobile navigation
     */
    const burgerIcon = document.querySelector(".primary-burger");
    const body = document.querySelector("body");

    burgerIcon.addEventListener("click", function () {
        body.classList.toggle("nav-is-open");
    });


    ////


    ///

});